/**
 * Utility function to determine the environment based on the current hostname.
 * This is used for both Sentry and OpenTelemetry configuration.
 * Only works in browser context - returns 'unknown' for server-side rendering.
 */
export function getEnvironment(): string | undefined {
  // Check if we're in a browser context
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  const hostname = window.location.hostname;

  if (
    hostname.endsWith('cartesian.io') ||
    hostname.endsWith('cartesian-prod.click')
  ) {
    return 'prod';
  }

  const envMatch = hostname.match(/cartesian-([^.]+)\.click$/);
  if (envMatch) {
    return envMatch[1]; // Will return 'staging' or 'dev' from the hostname
  }

  return 'unknown';
}

/**
 * Get the OpenTelemetry exporter URL based on the environment.
 */
export function getExporterUrl(environment: string): string {
  switch (environment) {
    case 'prod':
      return 'https://monitoring.cartesian.io';
    case 'dev':
      return 'https://monitoring.cartesian-dev.click';
    default:
      return 'http://localhost:6318';
  }
}
